(function () {
  var PER_PAGE = 5;
  var ROOT_SEL = '#crisp-home-reviews';
  var done = false;
  var rendering = false;

  function uniqueReviews(root) {
    var body = root.querySelector('.jdgm-all-reviews__body');
    if (!body) return [];
    var direct = Array.prototype.slice.call(body.children).filter(function (el) {
      return el.classList && el.classList.contains('jdgm-rev');
    });
    if (direct.length) return direct;
    return Array.prototype.slice.call(body.querySelectorAll(':scope > .jdgm-rev'));
  }

  function ensurePager(root, body) {
    var existing = root.querySelector('.crisp-reviews-pager');
    if (existing) return existing;
    var pager = document.createElement('nav');
    pager.className = 'crisp-reviews-pager';
    pager.setAttribute('aria-label', 'Review pages');
    pager.innerHTML =
      '<button type="button" class="crisp-reviews-pager__btn crisp-reviews-pager__prev" aria-label="Previous reviews">Previous</button>' +
      '<span class="crisp-reviews-pager__status" aria-live="polite"></span>' +
      '<button type="button" class="crisp-reviews-pager__btn crisp-reviews-pager__next" aria-label="Next reviews">Next</button>';
    if (body && body.parentNode) {
      body.parentNode.insertBefore(pager, body.nextSibling);
    } else {
      root.appendChild(pager);
    }
    return pager;
  }

  function render(root) {
    if (rendering) return;
    rendering = true;
    try {
      var body = root.querySelector('.jdgm-all-reviews__body');
      var reviews = uniqueReviews(root);
      if (!reviews.length) return;

      if (reviews.length <= PER_PAGE) {
        var old = root.querySelector('.crisp-reviews-pager');
        if (old) old.remove();
        reviews.forEach(function (el) {
          el.hidden = false;
          el.style.removeProperty('display');
        });
        done = true;
        return;
      }

      var pager = ensurePager(root, body);
      var page = parseInt(root.getAttribute('data-crisp-review-page') || '1', 10);
      var totalPages = Math.ceil(reviews.length / PER_PAGE);
      if (page < 1) page = 1;
      if (page > totalPages) page = totalPages;
      root.setAttribute('data-crisp-review-page', String(page));

      var start = (page - 1) * PER_PAGE;
      var end = start + PER_PAGE;
      reviews.forEach(function (el, i) {
        var show = i >= start && i < end;
        el.hidden = !show;
        el.style.display = show ? '' : 'none';
      });

      var status = pager.querySelector('.crisp-reviews-pager__status');
      var prev = pager.querySelector('.crisp-reviews-pager__prev');
      var next = pager.querySelector('.crisp-reviews-pager__next');
      status.textContent = 'Page ' + page + ' of ' + totalPages + ' · ' + reviews.length + ' reviews';
      prev.disabled = page <= 1;
      next.disabled = page >= totalPages;

      if (!pager._crispBound) {
        pager._crispBound = true;
        prev.addEventListener('click', function () {
          var p = parseInt(root.getAttribute('data-crisp-review-page') || '1', 10);
          root.setAttribute('data-crisp-review-page', String(Math.max(1, p - 1)));
          render(root);
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        next.addEventListener('click', function () {
          var p = parseInt(root.getAttribute('data-crisp-review-page') || '1', 10);
          var max = Math.ceil(uniqueReviews(root).length / PER_PAGE) || 1;
          root.setAttribute('data-crisp-review-page', String(Math.min(max, p + 1)));
          render(root);
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
      done = true;
    } finally {
      rendering = false;
    }
  }

  function tryRender() {
    if (done) return;
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;
    render(root);
  }

  function init() {
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;

    tryRender();

    // Poll a few times for Judge.me late content — no MutationObserver (it froze the page).
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      tryRender();
      if (done || attempts >= 20) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
